import React from "react";
import { Logo } from "./Logo";
export function Footer() {
  return <footer className="border-t border-neutral-200 bg-white px-4 py-10" data-id="element-135" data-mp="3gf93arl2hy6u">
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-6" data-id="element-136" data-mp="3ggk7utmc79z0">
        <Logo small data-id="element-137" data-mp="32p5mig4yiwos" />
        <p className="text-xs text-ink-muted" data-id="element-138" data-mp="32pp601a99t4x">© 2026 Woodworking Ready™. All rights reserved.</p>
      </div>
    </footer>;
}